"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferencedImagesNotFoundException = exports.LayersNotFoundException = exports.InvalidLayerPartException = exports.ImageTagAlreadyExistsException = exports.ImageDigestDoesNotMatchException = exports.ImageAlreadyExistsException = exports.RepositoryCatalogDataNotFoundException = exports.RegistryAliasStatus = exports.ImageNotFoundException = exports.RepositoryPolicyNotFoundException = exports.RepositoryNotEmptyException = exports.TooManyTagsException = exports.RepositoryAlreadyExistsException = exports.LimitExceededException = exports.InvalidTagParameterException = exports.UploadNotFoundException = exports.LayerPartTooSmallException = exports.LayerAlreadyExistsException = exports.InvalidLayerException = exports.EmptyUploadException = exports.ImageFailureCode = exports.UnsupportedCommandException = exports.ServerException = exports.RepositoryNotFoundException = exports.RegistryNotFoundException = exports.InvalidParameterException = exports.LayerAvailability = exports.LayerFailureCode = void 0;
const ECRPUBLICServiceException_1 = require("./ECRPUBLICServiceException");
exports.LayerFailureCode = {
    InvalidLayerDigest: "InvalidLayerDigest",
    MissingLayerDigest: "MissingLayerDigest",
};
exports.LayerAvailability = {
    AVAILABLE: "AVAILABLE",
    UNAVAILABLE: "UNAVAILABLE",
};
class InvalidParameterException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "InvalidParameterException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidParameterException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidParameterException.prototype);
    }
}
exports.InvalidParameterException = InvalidParameterException;
class RegistryNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RegistryNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "RegistryNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RegistryNotFoundException.prototype);
    }
}
exports.RegistryNotFoundException = RegistryNotFoundException;
class RepositoryNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RepositoryNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "RepositoryNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RepositoryNotFoundException.prototype);
    }
}
exports.RepositoryNotFoundException = RepositoryNotFoundException;
class ServerException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ServerException",
            $fault: "server",
            ...opts,
        });
        this.name = "ServerException";
        this.$fault = "server";
        Object.setPrototypeOf(this, ServerException.prototype);
    }
}
exports.ServerException = ServerException;
class UnsupportedCommandException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "UnsupportedCommandException",
            $fault: "client",
            ...opts,
        });
        this.name = "UnsupportedCommandException";
        this.$fault = "client";
        Object.setPrototypeOf(this, UnsupportedCommandException.prototype);
    }
}
exports.UnsupportedCommandException = UnsupportedCommandException;
exports.ImageFailureCode = {
    ImageNotFound: "ImageNotFound",
    ImageReferencedByManifestList: "ImageReferencedByManifestList",
    ImageTagDoesNotMatchDigest: "ImageTagDoesNotMatchDigest",
    InvalidImageDigest: "InvalidImageDigest",
    InvalidImageTag: "InvalidImageTag",
    KmsError: "KmsError",
    MissingDigestAndTag: "MissingDigestAndTag",
};
class EmptyUploadException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "EmptyUploadException",
            $fault: "client",
            ...opts,
        });
        this.name = "EmptyUploadException";
        this.$fault = "client";
        Object.setPrototypeOf(this, EmptyUploadException.prototype);
    }
}
exports.EmptyUploadException = EmptyUploadException;
class InvalidLayerException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "InvalidLayerException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidLayerException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidLayerException.prototype);
    }
}
exports.InvalidLayerException = InvalidLayerException;
class LayerAlreadyExistsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "LayerAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "LayerAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LayerAlreadyExistsException.prototype);
    }
}
exports.LayerAlreadyExistsException = LayerAlreadyExistsException;
class LayerPartTooSmallException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "LayerPartTooSmallException",
            $fault: "client",
            ...opts,
        });
        this.name = "LayerPartTooSmallException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LayerPartTooSmallException.prototype);
    }
}
exports.LayerPartTooSmallException = LayerPartTooSmallException;
class UploadNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "UploadNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "UploadNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, UploadNotFoundException.prototype);
    }
}
exports.UploadNotFoundException = UploadNotFoundException;
class InvalidTagParameterException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "InvalidTagParameterException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidTagParameterException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidTagParameterException.prototype);
    }
}
exports.InvalidTagParameterException = InvalidTagParameterException;
class LimitExceededException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "LimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LimitExceededException.prototype);
    }
}
exports.LimitExceededException = LimitExceededException;
class RepositoryAlreadyExistsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RepositoryAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "RepositoryAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RepositoryAlreadyExistsException.prototype);
    }
}
exports.RepositoryAlreadyExistsException = RepositoryAlreadyExistsException;
class TooManyTagsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "TooManyTagsException",
            $fault: "client",
            ...opts,
        });
        this.name = "TooManyTagsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TooManyTagsException.prototype);
    }
}
exports.TooManyTagsException = TooManyTagsException;
class RepositoryNotEmptyException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RepositoryNotEmptyException",
            $fault: "client",
            ...opts,
        });
        this.name = "RepositoryNotEmptyException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RepositoryNotEmptyException.prototype);
    }
}
exports.RepositoryNotEmptyException = RepositoryNotEmptyException;
class RepositoryPolicyNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RepositoryPolicyNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "RepositoryPolicyNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RepositoryPolicyNotFoundException.prototype);
    }
}
exports.RepositoryPolicyNotFoundException = RepositoryPolicyNotFoundException;
class ImageNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ImageNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImageNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImageNotFoundException.prototype);
    }
}
exports.ImageNotFoundException = ImageNotFoundException;
exports.RegistryAliasStatus = {
    ACTIVE: "ACTIVE",
    PENDING: "PENDING",
    REJECTED: "REJECTED",
};
class RepositoryCatalogDataNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "RepositoryCatalogDataNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "RepositoryCatalogDataNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RepositoryCatalogDataNotFoundException.prototype);
    }
}
exports.RepositoryCatalogDataNotFoundException = RepositoryCatalogDataNotFoundException;
class ImageAlreadyExistsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ImageAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImageAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImageAlreadyExistsException.prototype);
    }
}
exports.ImageAlreadyExistsException = ImageAlreadyExistsException;
class ImageDigestDoesNotMatchException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ImageDigestDoesNotMatchException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImageDigestDoesNotMatchException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImageDigestDoesNotMatchException.prototype);
    }
}
exports.ImageDigestDoesNotMatchException = ImageDigestDoesNotMatchException;
class ImageTagAlreadyExistsException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ImageTagAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "ImageTagAlreadyExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ImageTagAlreadyExistsException.prototype);
    }
}
exports.ImageTagAlreadyExistsException = ImageTagAlreadyExistsException;
class InvalidLayerPartException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "InvalidLayerPartException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidLayerPartException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidLayerPartException.prototype);
        this.registryId = opts.registryId;
        this.repositoryName = opts.repositoryName;
        this.uploadId = opts.uploadId;
        this.lastValidByteReceived = opts.lastValidByteReceived;
    }
}
exports.InvalidLayerPartException = InvalidLayerPartException;
class LayersNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "LayersNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "LayersNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LayersNotFoundException.prototype);
    }
}
exports.LayersNotFoundException = LayersNotFoundException;
class ReferencedImagesNotFoundException extends ECRPUBLICServiceException_1.ECRPUBLICServiceException {
    constructor(opts) {
        super({
            name: "ReferencedImagesNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ReferencedImagesNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ReferencedImagesNotFoundException.prototype);
    }
}
exports.ReferencedImagesNotFoundException = ReferencedImagesNotFoundException;
